var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolDeleteChatFix = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.7135C8.8234 17.7158 7.66203 17.4472 6.60587 16.9285C6.42427 16.8365 6.21643 16.81 6.01754 16.8535L3.07171 17.5344C2.98901 17.5536 2.9028 17.5514 2.82119 17.528C2.73958 17.5046 2.66526 17.4609 2.60524 17.4009C2.54521 17.3408 2.50146 17.2665 2.4781 17.1849C2.45473 17.1033 2.45254 17.0171 2.47171 16.9344L3.15171 13.9877C3.19754 13.7894 3.16754 13.5827 3.07754 13.3994C2.34022 11.896 2.11251 10.1933 2.42885 8.549C2.74518 6.90466 3.58836 5.40805 4.83086 4.2855C6.07335 3.16296 7.6476 2.47553 9.3155 2.32719C10.9834 2.17885 12.6543 2.57766 14.0754 3.4633C15.4965 4.34895 16.5905 5.67326 17.1921 7.23596M6.64171 8.24355H13.3584M6.64171 11.7669H8.75",
    stroke: "#1E1E1E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6719L19.1667 18.3385M19.1667 11.6719L12.5 18.3385",
    stroke: "#1E1E1E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolDeleteChatFix);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_delete_chat_fix.ab35677a4c7c96a60829875b858c77b1.svg";